<template>
    <div class="animated fadeIn">
        <h3>Inloggade</h3>
        <div class="card">
            <div class="card-body">
                <queryview ref="useractivity"
                    :qvtype="'UserActivity'"
                ></queryview>
            </div>
        </div>
    </div>
</template>
<script>
import queryview from "./../queryview/queryview";

export default {
    components:{queryview}    
}
</script>